import { Component, Inject } from "@angular/core";
import { Rule } from "../../../../common/models/flow.dto";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";
import { deepClone } from "../../../models/editor.model";

@Component({
    selector: "side-effect-modify-other-workflow-context",
    templateUrl: "./side-effect-modify-other-workflow-context.component.html",
    standalone: false
})
export class ModifyOtherWorkFlowContext {
    _seConfiguration: any;

    set seConfiguration(value: any) {
        this._seConfiguration = value || [];
        this._seConfiguration.organizationId = this._seConfiguration.organizationId || '';
        this._seConfiguration.transformMultiple = (this._seConfiguration.transformMultiple != null) ? this._seConfiguration.transformMultiple : false;
        
        if (!this._seConfiguration.transformations) {
            this._seConfiguration.transformations = [];
        }

        if (this._seConfiguration.transform) {
            for (let t = 0; t < this._seConfiguration.transform.length; t++) {
                let stored = this._seConfiguration.transform[t]; //anything stored under "transform" is just a rule, and so will need to be converted
                let clone = deepClone(stored);
                let transformation = new ModifyOtherWorkFlowContextConfig(clone, true, false);
                this._seConfiguration.transformations.push(transformation);
            }
            this._seConfiguration.transform = [];
        }

        for (let i = 0; i < this._seConfiguration.transformations.length; i++) {
            this._seConfiguration.transformations[i].targetIsArray = (this._seConfiguration.transformations[i].targetIsArray != null) ? this._seConfiguration.transformations[i].targetIsArray : false;
        }

        if (this._seConfiguration.transformations.length === 0) {
            this.addTransformation(this.addRule());
        }    
        
    }

    get seConfiguration(): any {        
        return this._seConfiguration;
    }
    
    showListNote: boolean = true;
    showWarning: boolean = true;

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.seConfiguration = data.configuration;
    }

    addRule(): Rule {
        return { name: '', expression: '' } as Rule;        
    }

    addTransformation(rule: Rule): void {
        let transform = new ModifyOtherWorkFlowContextConfig(rule, true, false);
        this.seConfiguration.transformations.push(transform);
    }

    removeTransformation(wf: ModifyOtherWorkFlowContextConfig): void {
        let index = this.seConfiguration.transformations.indexOf(wf);
        this.seConfiguration.transformations.splice(index, 1);
    }

    transformUpdated(rule: Rule, index: number): void {
        if (rule != null) {
            let existing = <ModifyOtherWorkFlowContextConfig>this.seConfiguration.transformations[index];
            rule.name = existing.rule.name;
            existing.rule = rule;
            this.seConfiguration.transformations[index] = existing;
        }
    }
}

export class ModifyOtherWorkFlowContextConfig {
    arrayExpected: boolean = false;
    copyAll: boolean = false;
    rule: Rule;
    targetIsArray: boolean = false;

    constructor (r: Rule, copy: boolean = true, expectArray: boolean = false) {
        this.rule = r;
        this.copyAll = copy;
        this.arrayExpected = expectArray;
    }
}
